import { PageBlockInstance } from "../../types/PageModel";
import { EntryMap } from "./EntryMap";

// eslint-disable-next-line no-empty-pattern
const NoopComponent = ({}: { entry: unknown }) => null;

export const EntryRenderer = ({
  pageBlockInstance,
}: {
  pageBlockInstance: PageBlockInstance;
}) => {
  const Component =
    EntryMap[pageBlockInstance.__typename]?.Component ?? NoopComponent;

  return <Component entry={pageBlockInstance.instance} />;
};
